import { shouldPolyfill as shouldPolyfillLocale } from '@formatjs/intl-locale/should-polyfill';
import { shouldPolyfill as shouldPolyfillCanonical } from '@formatjs/intl-getcanonicallocales/should-polyfill';
import ptBR from './pt-BR';
import esMX from './es-MX';

export async function polyfillIntl(locale = 'pt-BR') {
  if (typeof window === 'undefined') {
    return;
  }

  if (shouldPolyfillLocale()) {
    await import('@formatjs/intl-locale/polyfill');
  }

  if (shouldPolyfillCanonical()) {
    await import('@formatjs/intl-getcanonicallocales/polyfill');
  }


  switch (locale) {
    case 'es-MX':
      await esMX(locale);
      break;
    case 'pt-BR':
    default:
      await ptBR(locale);
      break;
  }
}
